import cx from 'classnames';
import LegendItem from "./LegendItem.js";
import LegendLabel from "./LegendLabel.js";
import LegendShape from "./LegendShape.js";
import valueOrIdentity, { valueOrIdentityString } from "../../util/valueOrIdentity.js";
import labelTransformFactory from "../../util/labelTransformFactory.js";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const defaultStyle = {
  display: 'flex'
};
export default function Legend(_ref) {
  let {
    className,
    style = defaultStyle,
    scale,
    shape,
    domain: inputDomain,
    fill = valueOrIdentityString,
    size = valueOrIdentityString,
    labelFormat = valueOrIdentity,
    labelTransform = labelTransformFactory,
    shapeWidth = 15,
    shapeHeight = 15,
    shapeMargin = '2px 4px 2px 0',
    shapeStyle,
    labelAlign = 'left',
    labelFlex = '1',
    labelMargin = '0 4px',
    itemMargin = '0',
    direction = 'column',
    itemDirection = 'row',
    legendLabelProps,
    children,
    ...legendItemProps
  } = _ref;
  // `Scale extends ScaleType` constraint is tricky
  //  could consider removing `scale` altogether in the future and making `domain: Datum[]` required
  const domain = inputDomain || ('domain' in scale ? scale.domain() : []);
  const labelFormatter = labelTransform({
    scale,
    labelFormat
  });
  const labels = domain.map(labelFormatter);
  if (children) return /*#__PURE__*/_jsx(_Fragment, {
    children: children(labels)
  });
  return /*#__PURE__*/_jsx("div", {
    className: cx('visx-legend', className),
    style: {
      ...style,
      flexDirection: direction
    },
    children: labels.map((label, i) => /*#__PURE__*/_jsxs(LegendItem, {
      margin: itemMargin,
      flexDirection: itemDirection,
      ...legendItemProps,
      children: [/*#__PURE__*/_jsx(LegendShape, {
        shape: shape,
        height: shapeHeight,
        width: shapeWidth,
        margin: shapeMargin,
        item: domain[i],
        itemIndex: i,
        label: label,
        fill: fill,
        size: size,
        shapeStyle: shapeStyle
      }), /*#__PURE__*/_jsx(LegendLabel, {
        label: label.text,
        flex: labelFlex,
        margin: labelMargin,
        align: labelAlign,
        ...legendLabelProps
      })]
    }, `legend-${label.text}-${i}`))
  });
}